import { render, staticRenderFns } from "./achievements-card.vue?vue&type=template&id=35d0f151&scoped=true"
import script from "./achievements-card.vue?vue&type=script&lang=js"
export * from "./achievements-card.vue?vue&type=script&lang=js"
import style0 from "./achievements-card.vue?vue&type=style&index=0&id=35d0f151&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d0f151",
  null
  
)

export default component.exports